/**
 * Proxy for naming of the redux actions
 * @template T
 * @param {T} actionNames
 * @param {string} name
 * @returns {T}
 */
export const createNamedActions = (name, actionNames) =>
  new Proxy(actionNames, {
    get(target, prop, receiver) {
      if (!(prop in target)) {
        return Reflect.get(target, prop, receiver);
      }

      return `@${name}/${target[prop]}`;
    },
  });
